/**
 * Compact metric tile for equipment show summary row.
 */
export const StatCard = ({ label, value, subtext, icon, tone = "default" }) => {
  const toneClasses = {
    default: "border-gray-200 bg-gray-50",
    success: "border-green-200 bg-green-50",
    warning: "border-amber-200 bg-amber-50",
    danger: "border-red-200 bg-red-50",
  };

  return (
    <div
      className={`rounded-lg border p-3 ${toneClasses[tone] || toneClasses.default}`}
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-medium uppercase tracking-wide text-gray-500">
          {label}
        </p>
        {icon ? <span className="text-gray-400">{icon}</span> : null}
      </div>
      <p className="mt-1 text-base font-semibold text-gray-900">{value}</p>
      {subtext ? <p className="mt-0.5 text-xs text-gray-600">{subtext}</p> : null}
    </div>
  );
};

export default StatCard;
